import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function usePublicSettings() {
  const { data } = useQuery({
    queryKey: ["public-settings"],
    queryFn: async () => (await api.get("/settings/public")).data,
    staleTime: 5 * 60 * 1000,
  });
  return data || {};
}
